import React from 'react'
import { TransactionWrapper } from './transactionListHeadingStyle'
import { TransactionListinfo } from './TransactionListinfo'
const TransactionListHeading = () => {
  return (
    <TransactionWrapper>
      <div className="transactionHeading lg">
        <div className="type">
          <p className="title">Type</p>
        </div>
        <div className="amount">
          <p className="title">Amount</p>
        </div>
        <div className="date">
          <p className="title">Date</p>
        </div>
        <div className="description">
          <p className="title">Description</p>
        </div>

        <div className="status">
          <p className="title">Status</p>
        </div>
      </div>
      <TransactionListinfo />
    </TransactionWrapper>
  )
}

export { TransactionListHeading }
